import { jsxs, jsx } from 'react/jsx-runtime';
import { themedColor, disabledInteraction, Flex, font, cssValue, conditionalInclude, useMaskedValue, usePasteValueTransform, preventOneWordInLastLine } from '@lemonade-hq/cdk';
import { applyMask } from '@lemonade-hq/ts-helpers';
import { rgba } from 'polished';
import React, { forwardRef, useMemo, useCallback, useRef, useLayoutEffect } from 'react';
import styled, { css } from 'styled-components';
import { borderHighlight, animatedHighlight, rounded, styledPlaceholder } from '../../styles/common.esm.js';
import { InputIcon } from '../InputIcon/InputIcon.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  :active,\n  :focus {\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  box-shadow: unset;\n\n  :hover {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  border-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n          border-right: 0;\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n          border-left: 0;\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  ",
        ";\n  text-align: center;\n  flex-shrink: 0;\n  border: solid 1px ",
        ";\n  padding: 0 10px;\n  height: inherit;\n  justify-content: center;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  left: 16px;\n  ",
        ";\n  transition: all 0.15s ease-out;\n  user-select: none;\n  transform-origin: 0 100%;\n  transform: translateY(-50%);\n  cursor: text;\n  color: ",
        ";\n  text-transform: uppercase;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 17px;\n  text-transform: uppercase;\n  cursor: text;\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n      background-color: ",
        ";\n\n      & + ",
        " {\n        opacity: 0;\n      }\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n        padding: 24px 15px 8px;\n\n        & + ",
        " {\n          opacity: 1;\n        }\n      "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n    width: ",
        ";\n    height: ",
        ";\n    ",
        "\n    ",
        "\n        ",
        "\n        ",
        "\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  appearance: none;\n  box-sizing: border-box;\n  color: ",
        ";\n  padding: 15px;\n  border: 1px solid ",
        ";\n  outline: none;\n  transition: all 0.15s ease-out;\n  ",
        ";\n  ",
        "\n  ",
        "\n    ",
        ";\n\n  ",
        "\n\n  &:hover, &:focus {\n    border-color: ",
        ";\n    background-color: ",
        ";\n\n    ",
        "\n  }\n\n  ",
        "\n  ",
        "\n\n    ",
        "\n        \n  /* Remove arrows on number inputs */\n  /* Chrome, Safari, Edge, Opera */\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  /* Firefox */\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n      ",
        " {\n        padding-left: 42px;\n      }\n\n      ",
        " {\n        padding-left: ",
        ";\n      }\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n  flex: 1;\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n          margin-right: 6px;\n        "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n          margin-left: 6px;\n        "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
var SIDE_LABEL_BACKGROUND_OPACITY = 0.6;
var highlightStyle = css(_templateObject(), borderHighlight, animatedHighlight);
var highlightErrorStyle = css(_templateObject1(), borderHighlight, themedColor("primary"));
var errorStyle = css(_templateObject2(), themedColor("primary"));
var disabledView = css(_templateObject3(), disabledInteraction, themedColor("cloud"), themedColor("metal"));
var SideLabel = styled(Flex)(_templateObject7(), rounded, font("main", {
    fontSize: "1.3rem",
    fontWeight: 700
}), themedColor("glass"), function(param) {
    var theme = param.theme;
    return css(_templateObject4(), rgba(theme.colors.cloud, SIDE_LABEL_BACKGROUND_OPACITY));
}, function(param) {
    var labelPosition = param.labelPosition;
    return labelPosition === "left" ? css(_templateObject5()) : css(_templateObject6());
});
var SideLabelText = styled.p(_templateObject8());
var InputLabel = styled.label(_templateObject9(), font("main", {
    fontSize: "1.4rem",
    fontWeight: 700
}), themedColor("metal"), function(param) {
    var hasValue = param.hasValue;
    return hasValue && "transform: translateY(0) scale(0.75);\n        top: 3px;\n        font-size: 1.3rem;\n    ";
}, function(param) {
    var disabled = param.disabled;
    return disabled && disabledInteraction;
});
var AdditionalInnerLabel = styled.label(_templateObject10(), function(param) {
    var emojiInnerLabel = param.emojiInnerLabel;
    return font("main", {
        fontSize: emojiInnerLabel ? "2rem" : "1.1rem",
        fontWeight: 700
    });
}, themedColor("light"), function(param) {
    var hasValue = param.hasValue;
    return hasValue && "display: none;\n    ";
});
var InputElement = styled.input(_templateObject16(), themedColor("night"), themedColor("glass"), rounded, styledPlaceholder, font("main", {
    fontSize: "1.4rem",
    fontWeight: 700
}), function(param) {
    var theme = param.theme, frozen = param.frozen, hasValue = param.hasValue;
    return frozen && hasValue && css(_templateObject11(), rgba(theme.colors.cloud, SIDE_LABEL_BACKGROUND_OPACITY), InputLabel);
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform != null && "text-transform: ".concat(textTransform, ";\n    ");
}, themedColor("pebble"), themedColor("white"), function(param) {
    var hasValue = param.hasValue, _param_floatingLabel = param.floatingLabel, floatingLabel = _param_floatingLabel === void 0 ? false : _param_floatingLabel;
    return hasValue && floatingLabel && css(_templateObject12(), InputLabel);
}, function(param) {
    var _param_width = param.width, width = _param_width === void 0 ? "100%" : _param_width, _param_highlight = param.highlight, highlight = _param_highlight === void 0 ? false : _param_highlight, _param_error = param.error, error = _param_error === void 0 ? false : _param_error, _param_height = param.height, height = _param_height === void 0 ? "47px" : _param_height, _param_highlightError = param.highlightError, highlightError = _param_highlightError === void 0 ? false : _param_highlightError, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, hasValue = param.hasValue;
    return css(_templateObject13(), cssValue(width), cssValue(height), conditionalInclude(highlight && !hasValue, highlightStyle), conditionalInclude(highlightError, highlightErrorStyle), conditionalInclude(error, errorStyle), conditionalInclude(disabled, disabledView));
}, function(param) {
    var hasValue = param.hasValue, _param_floatingLabel = param.floatingLabel, floatingLabel = _param_floatingLabel === void 0 ? false : _param_floatingLabel, frozen = param.frozen;
    return hasValue && floatingLabel && !frozen && "padding: 24px 15px 8px;\n    ";
}, function(param) {
    var hasSideLabel = param.hasSideLabel, sideLabelPosition = param.sideLabelPosition;
    return hasSideLabel && (sideLabelPosition === "left" ? css(_templateObject14()) : css(_templateObject15()));
});
var InputContainer = styled(Flex)(_templateObject17(), function(param) {
    var width = param.width;
    return width != null && "width: ".concat(width, ";\n    ");
});
var InnerInputContainer = styled.div(_templateObject19(), function(param) {
    var hasIcon = param.hasIcon, hasValue = param.hasValue;
    return hasIcon && css(_templateObject18(), InputElement, InputLabel, hasValue ? "36px" : "27px");
});
var SideLabelInputIcon = styled(InputIcon)(_templateObject22(), function(param) {
    var labelPosition = param.labelPosition;
    return labelPosition === "left" ? css(_templateObject20()) : css(_templateObject21());
});
var StyledInputIcon = styled(InputIcon)(_templateObject23());
var useFixCursorPosition = function(param) {
    var inputRef = param.inputRef, ignoreCursorPosition = param.ignoreCursorPosition;
    var inputCursorPosition = useRef(0);
    var ref = inputRef !== null && inputRef !== void 0 ? inputRef : /*#__PURE__*/ React.createRef();
    useLayoutEffect(function() {
        var _typedRef_current;
        var typedRef = ref;
        if (!ignoreCursorPosition && ((_typedRef_current = typedRef.current) === null || _typedRef_current === void 0 ? void 0 : _typedRef_current.setSelectionRange) != null && inputCursorPosition.current != null && document.activeElement === typedRef.current) {
            try {
                // try/catch is for annoying types such as email and number where setSelectionRange throws an error
                ref.current.setSelectionRange(inputCursorPosition.current, inputCursorPosition.current);
            } catch (e) {
            // do nothing
            }
        }
    }, [
        ignoreCursorPosition,
        ref
    ]);
    return {
        inputCursorPosition: inputCursorPosition,
        ref: ref
    };
};
var Input = function(_param, inputRef) {
    var id = _param.id, placeholder = _param.placeholder, value = _param.value, onChange = _param.onChange, className = _param.className, _param_type = _param.type, type = _param_type === void 0 ? "text" : _param_type, _param_floatingLabel = _param.floatingLabel, floatingLabel = _param_floatingLabel === void 0 ? true : _param_floatingLabel, _param_frozen = _param.frozen, frozen = _param_frozen === void 0 ? false : _param_frozen, mask = _param.mask, additionalInnerLabel = _param.additionalInnerLabel, emojiInnerLabel = _param.emojiInnerLabel, icon = _param.icon, pasteTransform = _param.pasteTransform, _param_textTransform = _param.textTransform, textTransform = _param_textTransform === void 0 ? "none" : _param_textTransform, sideLabel = _param.sideLabel, _param_sideLabelPosition = _param.sideLabelPosition, sideLabelPosition = _param_sideLabelPosition === void 0 ? "left" : _param_sideLabelPosition, width = _param.width, ignoreCursorPosition = _param.ignoreCursorPosition, ariaLabel = _param["aria-label"], transform = _param.transform, floatingLabelText = _param.floatingLabelText, nativeInputProps = _object_without_properties(_param, [
        "id",
        "placeholder",
        "value",
        "onChange",
        "className",
        "type",
        "floatingLabel",
        "frozen",
        "mask",
        "additionalInnerLabel",
        "emojiInnerLabel",
        "icon",
        "pasteTransform",
        "textTransform",
        "sideLabel",
        "sideLabelPosition",
        "width",
        "ignoreCursorPosition",
        "aria-label",
        "transform",
        "floatingLabelText"
    ]);
    var _useFixCursorPosition = useFixCursorPosition({
        inputRef: inputRef,
        ignoreCursorPosition: ignoreCursorPosition
    }), inputCursorPosition = _useFixCursorPosition.inputCursorPosition, ref = _useFixCursorPosition.ref;
    var _useMaskedValue = useMaskedValue({
        value: value,
        mask: mask,
        onChange: onChange
    }), maskedValue = _useMaskedValue.maskedValue, onChangeWithMask = _useMaskedValue.onChangeWithMask;
    var memoizedId = useMemo(function() {
        return id !== null && id !== void 0 ? id : Math.random().toString();
    }, [
        id
    ]);
    var onPaste = usePasteValueTransform({
        transform: pasteTransform
    }).onPaste;
    var placeholderText = floatingLabel ? "" : placeholder;
    var hasValue = value != null && "".concat(value).length > 0;
    var onChangeWithMaskAndCursorPositionFix = useCallback(function(e) {
        var _e_target_selectionStart;
        inputCursorPosition.current = mask != null ? applyMask(mask, e.target.value.substring(0, (_e_target_selectionStart = e.target.selectionStart) !== null && _e_target_selectionStart !== void 0 ? _e_target_selectionStart : 0)).length : e.target.selectionStart;
        if (transform) {
            inputCursorPosition.current = e.target.value.length + 1;
            e.target.value = "".concat(transform.from(e.target.value));
        }
        onChangeWithMask(e);
    }, [
        inputCursorPosition,
        mask,
        onChangeWithMask,
        transform
    ]);
    var memoizedValue = useMemo(function() {
        if (transform != null && mask != null) {
            // eslint-disable-next-line no-console
            console.warn("Please refrain from using both mask and numberFormatting at the same time");
        }
        return transform != null ? transform.to(transform.from(maskedValue !== null && maskedValue !== void 0 ? maskedValue : "")) : maskedValue;
    }, [
        maskedValue,
        mask,
        transform
    ]);
    return /*#__PURE__*/ jsxs(InputContainer, {
        className: className,
        flexDirection: sideLabelPosition === "left" ? "row" : "row-reverse",
        width: width,
        children: [
            sideLabel != null && /*#__PURE__*/ jsxs(SideLabel, {
                alignItems: "center",
                "aria-label": sideLabel,
                flexDirection: sideLabelPosition === "left" ? "row" : "row-reverse",
                labelPosition: sideLabelPosition,
                children: [
                    icon != null && /*#__PURE__*/ jsx(SideLabelInputIcon, {
                        icon: icon,
                        labelPosition: sideLabelPosition
                    }),
                    /*#__PURE__*/ jsx(SideLabelText, {
                        dangerouslySetInnerHTML: {
                            __html: preventOneWordInLastLine(sideLabel)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ jsxs(Flex, {
                flex: 1,
                position: "relative",
                children: [
                    icon != null && sideLabel == null && /*#__PURE__*/ jsx(StyledInputIcon, {
                        icon: icon
                    }),
                    /*#__PURE__*/ jsxs(InnerInputContainer, {
                        className: "".concat(type, "-container"),
                        hasIcon: icon != null && sideLabel == null,
                        hasValue: hasValue,
                        children: [
                            /*#__PURE__*/ jsx(InputElement, _object_spread({
                                floatingLabel: floatingLabel,
                                frozen: frozen,
                                hasSideLabel: sideLabel != null,
                                hasValue: hasValue,
                                id: memoizedId,
                                onChange: onChangeWithMaskAndCursorPositionFix,
                                onPaste: onPaste,
                                placeholder: placeholderText,
                                ref: ref,
                                sideLabelPosition: sideLabelPosition,
                                textTransform: textTransform,
                                type: type,
                                value: memoizedValue
                            }, nativeInputProps, floatingLabel ? {
                                "aria-labelledby": "".concat(memoizedId, "-label")
                            } : {
                                "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : placeholder
                            })),
                            floatingLabel && /*#__PURE__*/ jsx(InputLabel, {
                                "data-testid": "floating-label",
                                disabled: nativeInputProps.disabled,
                                hasValue: hasValue,
                                htmlFor: memoizedId,
                                id: "".concat(memoizedId, "-label"),
                                children: hasValue && floatingLabelText != null ? floatingLabelText : placeholder
                            })
                        ]
                    }),
                    additionalInnerLabel != null && /*#__PURE__*/ jsx(AdditionalInnerLabel, {
                        emojiInnerLabel: emojiInnerLabel,
                        hasValue: hasValue,
                        children: additionalInnerLabel
                    })
                ]
            })
        ]
    });
};
var InputText = /*#__PURE__*/ forwardRef(Input);

export { AdditionalInnerLabel, InnerInputContainer, InputElement, InputLabel, InputText, SideLabel };
